import React, { useEffect, useState } from 'react';
import Blog from './pages/blog/Blog';
import BrandsListing from './pages/brands-listing/BrandsListing';
import Category from './pages/category/Category';
import Dashboard from './pages/dashboard/Dashboard';
import MyBag from './pages/my-bag/MyBag';
import ProductDesc from './pages/product-description/ProductDesc';
import Login from './pages/login/Login'
import ResetPassword from './pages/reset-pw/ResetPassword'
import SignUp from "./pages/signup/Signup"
import VerifyOtp from './pages/verify-otp/VerifyOtp'
import NewPassword from './pages/new-password/NewPassword';
import CompleteProfile from './pages/complete-profile/CompleteProfile'
import Search from './pages/search/Search'
import Brand from './pages/brand-page/Brand'
import MyOrders from './pages/orders/MyOrders'
import OrderDetails from './pages/order-details/OrderDetails'
import RefundDetails from './pages/refund-details/RefundDetails'
import Address from './pages/address/Address'
import PaymentMethods from './pages/payment/PaymentMethods'
import Profile from './pages/profile/Profile'
import AddAddress from './pages/add-address/AddAdress'
import SpecialCategories from './pages/special-categories/SpecialCategories'
import SelectPaymentMethod from './pages/select-payment-method/select-payment-method'
import { WebApiCalls } from "./webApiCalls/webApiCalls"
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect
} from "react-router-dom";
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'

import { createBrowserHistory } from "history";
import MyStorage from './common/MyStorage';
import ReactPixel, { Options } from 'react-facebook-pixel'

const fbOptions: Options = {
	autoConfig: true,
	debug: false
};
ReactPixel.init('917432229084927', undefined, fbOptions);
const history = createBrowserHistory();

function App() {
	const [checkState, setCheckState] = useState(true)
	const [userID, setUserID] = useState('')
	const [access_token, setAccessToken] = useState('')

	const getOs = () => {
        const os = ['Windows', 'Linux', 'Mac', 'Android', 'iPhone']; // add your OS values
        let filteredOS = os.find(v => navigator.appVersion.indexOf(v) >= 0);
        if (filteredOS == 'Linux') {
            filteredOS = 'Mac'
        } else if (filteredOS == 'Mac') {
            filteredOS = 'iOS'
        }
        return filteredOS;
    }

	useEffect(() => {

		ReactPixel.track(`pageviewed`, {
			'OS': getOs(),
			'Platform': 'App',
			'Current Page': window.location.pathname,
			'Previous Page': window.location.pathname,
			'Step': ''
		});
		
		const fetchingToken = async (data: any) => {
			if (checkState) {
				setCheckState(false)
				const storage = new MyStorage();
				let userID = storage.getUserId();
				let access_token = storage.getaccess_token();
				let ssoCode = storage.getSsoCode()
				if(!userID && !access_token && !ssoCode){
					let obj = {
						contactID: data.contact_id,
						email: data.email,
						authentication: data.authentication,
						phoneNumber: data.phoneNumber,
						name: data.name
					};
					storage.setContactIDFrasers(obj.contactID);
					// storage.setEmailFrasers(obj.email);
					storage.setauthenticationFrasers(obj.authentication);
					// storage.setPhoneNumber(obj.phoneNumber);
					storage.setName(obj.name);
					await new WebApiCalls().getToken(obj).then(async (response) => {
						if (response.AccessToken) {
							storage.setUserId(response.AccessToken.UserId)
							storage.setaccess_token(response?.AccessToken?.access_token)
							storage.setSsoCode(response.SsoCode)
							setUserID(response?.AccessToken?.UserId)
							setAccessToken(response?.AccessToken?.access_token)
						}
						let body = {
							FirstName: data.firstName,
							LastName: data.lastName,
							DisplayName: data.name,
							Description: data.contact_id
						}
						await new WebApiCalls()
							.updateUserInfo(response?.AccessToken?.UserId, body, response?.AccessToken?.access_token).then((response) => {
							})
					});
				}
				else{
					let body = {
						FirstName: data.firstName,
						LastName: data.lastName,
						DisplayName: data.name,
						Description: data.contact_id
					}
					await new WebApiCalls()
						.updateUserInfo(userID, body, access_token).then((response) => {
					})
				}
				
			}
		};
		const setData = async () => {
			const storage = new MyStorage()
			const login = storage.getloggedIn()
			const userID = storage.getUserId()
			await new WebApiCalls()
					.getUserInfo(userID)
					.then((response) => {
						if (login === "true") {
							let obj = {};
							obj["contact_id"] =  storage.getContactIDFrasers();
							obj["email"] = response.Email;
							obj["phoneNumber"] = response.PhoneNumber;
							obj["authenticationFrasers"] =  storage.getauthenticationFrasers();
							obj["name"] =  storage.getName();
							obj["authentication"] =  storage.getauthenticationFrasers();
							fetchingToken(obj);
							}	
						});
		}
		setData();
	}, [])


	return (
		<Router history={history}>
			<CacheSwitch>
				<Route exact path="/" render={(routeProps) => <Dashboard {...routeProps} />} />
				<Redirect from="/home/:logged?" to="/" />
				<Redirect from="/dashboard" to="/" />
				<Route path="/login" render={(routeProps) => <Login {...routeProps} />} />
				<Route path="/reset-pw" render={(routeProps) => <ResetPassword {...routeProps} />} />
				<Route path="/sign-up" render={(routeProps) => <SignUp {...routeProps} />} />
				<Route path="/verify-otp" render={(routeProps) => <VerifyOtp {...routeProps} />} />
				<Route path="/new-pw" render={(routeProps) => <NewPassword {...routeProps} />} />
				<Route path="/complete-profile" render={(routeProps) => <CompleteProfile {...routeProps} />} />
				<Route path="/product/:productName/:productID" render={(routeProps) => <ProductDesc {...routeProps} />} />
				<Route path="/my-bag" render={(routeProps) => <MyBag {...routeProps} />} />
				<Route path="/brands-list/" render={(routeProps) => <BrandsListing {...routeProps} />} />
				{/* <Route path="/category/:name" render={(routeProps) => <Category {...routeProps} />} /> */}
				<Route path="/brand/:brandName/:brandID?" render={(routeProps) => <Brand {...routeProps} />} />
				{/* <Route path="/category/:name/:ID?" render={(routeProps) => <Category {...routeProps} />} /> */}
				{/* @ts-ignore */}
				<CacheRoute path="/category/:name/:ID?" render={(routeProps) => <Category {...routeProps} />} />
				<Route path="/brand/:brandName" render={(routeProps) => <Brand {...routeProps} />} />
				<Route path="/blog/:blogID" render={(routeProps) => <Blog {...routeProps} />} />
				<Route path="/search/:keywords?" render={(routeProps) => <Search {...routeProps} />} />
				<Route path="/my-orders/:isRefund?" render={(routeProps) => <MyOrders {...routeProps} />} />
				<Route path="/order-details/:orderID" render={(routeProps) => <OrderDetails {...routeProps} />} />
				<Route path="/refund-details/:orderID" render={(routeProps) => <RefundDetails {...routeProps} />} />
				<Route path="/address-book" render={(routeProps) => <Address {...routeProps} />} />
				<Route path="/payment-methods" render={(routeProps) => <PaymentMethods {...routeProps} />} />
				<Route path="/profile" render={(routeProps) => <Profile {...routeProps} />} />
				<Route path="/add-address" render={(routeProps) => <AddAddress {...routeProps} />} />
				{/* @ts-ignore */}
				<CacheRoute path="/categories-listing/:cat_name/:catID?" render={(routeProps) => <SpecialCategories {...routeProps} />} />
				<Route path="/select-payment-method" render={(routeProps) => <SelectPaymentMethod {...routeProps} />} />
				<Route render={() => <Redirect to={{pathname: "/"}} />} />
			</CacheSwitch>
		</Router>
	);
}

export default App;
